import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import './App.css';
import Login from './Components/Login/Login';
import secureLocalStorage from 'react-secure-storage';
import Sider from 'antd/es/layout/Sider';
import { Layout, Menu } from 'antd';
import { signOut } from 'firebase/auth';
import { auth } from './firebase/firebaseConfig';
import { DollarOutlined, LogoutOutlined, UserAddOutlined } from '@ant-design/icons';
import Admin from './Components/Admin/Admin';
import Invoices from './Components/Invoices/Invoices';

function App () {
  const [ key, setKey ] = useState( "0" );
  function getItem ( label, key, icon, href ) {
    return {
      label,
      key,
      icon,
      href
    };
  }
  const items = [
    getItem( 'Api Users', '0', <UserAddOutlined />, "/" ),
    getItem( 'Invoices', '1', <DollarOutlined />, "/invoices" ),
    getItem( 'Log Out', '16', <LogoutOutlined />, "/" ),
  ];

  let login = secureLocalStorage.getItem( "login" );

  useEffect( () => {
    if ( secureLocalStorage.getItem( "login" ) ) {
      let time = new Date( secureLocalStorage.getItem( "loginTime" ) );
      let currentTime = new Date();
      if ( ( currentTime - time ) >= 180202002 ) {
        secureLocalStorage.removeItem( "login" );
        secureLocalStorage.removeItem( "loginTime" );
        signOut( auth );
        setTimeout( () => {
          window.location.reload();
        }, 800 );
      }
    }
  }, [ login ] );

  return (
    <BrowserRouter>
      <div className="App">
        <Layout
          style={{
            minHeight: '100vh',
          }}
        >
          <Sider collapsed={false} style={{ width: "250px" }}>
            <div className="demo-logo-vertical" />
            <Menu theme="light" selectedKeys={[ key ]} mode="inline" items={items} onClick={event => {
              if ( event.key !== "16" ) {
                document.querySelector( ".menu-link-" + event.key ).click();
                setKey( event.key );
              } else {
                secureLocalStorage.removeItem( "login" );
                secureLocalStorage.removeItem( "loginTime" );
                signOut( auth );
                window.location.reload();
              }
            }} />
            {items.map( ( element ) => (
              <Link className={'menu-link-' + element.key} to={element.href} style={{ display: "none" }}>Click</Link>
            ) )}
          </Sider>
          <Layout>
            <Routes>
              <Route path='/login' element={<Login />} />
              <Route path='*' exact={true} element={<Admin />} />
              <Route path='/' exact={true} element={<Admin />} />
              <Route path='/invoices' exact={true} element={<Invoices />} />
            </Routes>
          </Layout>
        </Layout>
      </div>
    </BrowserRouter>
  );
}

export default App;
